export const getIOEntryDeviceExternalId = (macAddress: string, index: number): string => {
  return `${macAddress}_ingang_${index}`;
};
